const {locationString, bagString,basketString,cartString} = require('./assets/icons');

//Code snippet of BounceMarker
/**
 * Copyright (C) 2013 Maxime Hadjinlian <maxime.hadjinlian@gmail.com>
 * All Rights Reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

(function() {
    // Retain the value of the original onAdd and onRemove functions
    let originalOnAdd = L.Marker.prototype.onAdd;
    let originalOnRemove = L.Marker.prototype.onRemove;

    // Add bounceonAdd options
    L.Marker.mergeOptions({
        bounceOnAdd: false,
        bounceOnAddOptions: {
            duration: 1000,
            height: -1,
            loop: 1,
        },
        bounceOnAddCallback: function() {},
    });

    L.Marker.include({

        _toPoint: function(latlng) {
            return this._map.latLngToContainerPoint(latlng);
        },

        _toLatLng: function(point) {
            return this._map.containerPointToLatLng(point);
        },

        _motionStep: function(opts) {
            let self = this;
            let timePassed = new Date() - opts.start;
            let progress = timePassed / opts.duration;

            if (progress > 1) {
                progress = 1;
            }

            let delta = self._easeOutBounce(progress);
            opts.step(delta);

            if (progress === 1) {
                opts.start = new Date();
                progress = 0;
                if (opts.loop > 0) opts.loop = opts.loop - 1;
                if (opts.loop === 0) {
                    opts.end();
                    return;
                }
            }

            self._animationId = L.Util.requestAnimFrame(function(timestamp) {
                self._motionStep(opts);
            });
        },

        _bounceMotion: function(opts, callback) {
            let original = L.latLng(this._origLatlng);
            let start_y = this._dropPoint.y;
            let start_x = this._dropPoint.x;
            let distance = this._point.y - start_y;
            let self = this;

            self._animationId = L.Util.requestAnimFrame(function() {
                self._motionStep({
                    duration: opts.duration || 1000, // 1 sec by default
                    loop: opts.loop || 1,
                    start: new Date(),
                    step: function(delta) {
                        self._dropPoint.y =
                            start_y
                            + (distance * delta)
                            - (self._map.project(self._map.getCenter()).y - self._origMapCenter.y);
                        self._dropPoint.x =
                            start_x
                            - (self._map.project(self._map.getCenter()).x - self._origMapCenter.x);
                        self.setLatLng(self._toLatLng(self._dropPoint));
                    },
                    end: function() {
                        self.setLatLng(original);
                        if (typeof callback === 'function') callback();
                    },
                });
            });
        },

        // Many thanks to Robert Penner for this function
        _easeOutBounce: function(pos) {
            if ((pos) < (1 / 2.75)) {
                return (7.5625 * pos * pos);
            } else if (pos < (2 / 2.75)) {
                return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
            } else if (pos < (2.5 / 2.75)) {
                return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
            } else {
                return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
            }
        },

        // Bounce : if options.height in pixels is not specified, drop from top.
        // If options.duration is not specified animation is 1s long.
        bounce: function(options, endCallback) {
            if (typeof options === 'function') {
                endCallback = options;
                options = null;
            }
            options = options || {duration: 1000, height: -1, loop: 1};

            // backward compatibility
            if (typeof options === 'number') {
                options.duration = arguments[0];
                options.height = arguments[1];
            }

            // Keep original map center
            this._origMapCenter = this._map.project(this._map.getCenter());
            this._dropPoint = this._getDropPoint(options.height);
            this._bounceMotion(options, endCallback);
        },

        stopBounce: function(){
            // We may have modified the marker; so we need to place it where it
            // belongs so next time its coordinates are not changed.
            this.setLatLng(this._origLatlng);
            L.Util.cancelAnimFrame(this._animationId);
        },

        // This will get you a drop point given a height.
        // If no height is given, the top y will be used.
        _getDropPoint: function(height) {
            // Get current coordidates in pixel
            this._point = this._toPoint(this._origLatlng);
            let top_y;
            if (height === undefined || height < 0) {
                top_y = this._toPoint(this._map.getBounds()._northEast).y;
            } else {
                top_y = this._point.y - height;
            }
            return new L.Point(this._point.x, top_y);
        },

        onAdd: function(map) {
            this._map = map;

            // Call leaflet original method to add the Marker to the map.
            originalOnAdd.call(this, map);

            // Keep original latitude and longitude
            this._origLatlng = this.getLatLng();

            if (this.options.bounceOnAdd === true) {
                this.bounce(this.options.bounceOnAddOptions, this.options.bounceOnAddCallback);
            }
        },

        onRemove: function(map) {
            this.stopBounce();
            originalOnRemove.call(this, map);
        },
    });
})();
//END of Bouncermarker.js

//Capitalize a string
function capitalizeFirstLetter(nameS) {
    let result = ''
    let words = nameS.split(' ');
    let lowerWords = ['of', 'and'];
    let upperWords = ['llc']
    words.forEach(function (word) {
        word = word.toLowerCase();
        if (upperWords.includes(word)){result += word.toUpperCase()+' ';}
        else if (lowerWords.includes(word)){result += word+' ';}
        else{result += word.charAt(0).toUpperCase()+word.slice(1)+' ';}

    })
    return result;

}
//end of capitalization of words

const mapLink = '<a href="https://openstreetmap.org">OpenStreetMap</a>';
const userLink = '<a href="mailto:guixing_wei@brown.edu">Guixing Wei@S4</a>';
const mapsURL = 'https://services.arcgis.com/8veDRDlhXWywYP3S/arcgis/rest/services/FoodAndNutrition_ViewLayer/FeatureServer';
const layersIndex = {gardens: 0, foodB: 1, wic: 2, snap: 3, convenienceS: 4,groceryS: 5};
const svgStrings = {gardens: basketString, foodB: bagString, wic: bagString, snap: bagString, convenienceS: cartString, groceryS: cartString};
var dropdown_span = document.querySelector('#layers-toggle span');

var layers = {}; //containers of all feature layers

const vars_dict = {
    gardens: {pop_name: 'USER_Name', pop_address: 'Match_addr', pop_conp1: 'USER_Contact1', pop_conp2: 'USER_Contact2', pop_conm1: 'USER_Contact1Method', pop_conm2: 'USER_Contact2Method', pop_manage: "USER_Management"},
    foodB: {pop_name: 'Name', pop_address: 'Match_addr', pop_conp: 'Contact_Name',pop_phone: 'Phone', pop_service: 'Service', pop_hours: 'HoursComments'},
    wic: {pop_name: 'USER_Tradename', pop_address: 'USER_Address', pop_city: 'USER_City', pop_state: 'USER_State', pop_pharmacy: 'USER_Pharmacy', pop_ewic: 'USER_eWIC_Certified'},
    snap: {pop_name: 'Store_Name', pop_address: 'Address', pop_city: "City", pop_state: "State"},
    convenienceS: {pop_name: 'Name', pop_address: 'Match_addr', pop_phone: 'Phone'},
    groceryS: {pop_name: 'Name', pop_address: 'Address', pop_city: 'City', pop_state: 'State',pop_phone: 'Phone'}
}
//pop-up attributes

var popupHTMLs = {
    gardens: function (vals){return `<h5>${vals.pop_name}</h5><hr><b>Address:</b> ${vals.pop_address}<br><b>Contact:</b> ${vals.pop_conp1=="Name Not Available"? '': vals.pop_conp1}&nbsp;${vals.pop_conp2=='No Second Contact'? ' ':vals.pop_conp2}<br> <b>Contact Methods:</b> ${vals.pop_conm1=='Contact Not Available'? '':vals.pop_conm1}${vals.pop_conm2=='No Second Contact Method'? '':'<br>'+vals.pop_conm2}<br><b>Management:</b> ${vals.pop_manage}`},
    foodB: function (vals) {return `<h5>${vals.pop_name}</h5><hr><b>Address:</b> ${vals.pop_address}<br><b>Contact:</b> ${vals.pop_conp}<br> <b>Phone:</b> ${vals.pop_phone}<br><b>Service:</b> ${vals.pop_service}<hr><b>Hours Comments:</b><br>${vals.pop_hours}`},
    wic: function (vals) {return`<h5>${vals.pop_name}</h5><hr><b>Address:</b> ${vals.pop_address},${vals.pop_city}, ${vals.pop_state}<br><b>Pharmacy:</b> ${vals.pop_pharmacy}<br> <b>eWIC Certified:</b> ${vals.pop_ewic}`},
    snap: function (vals) {return`<h5>${vals.pop_name}</h5><hr><b>Address:</b> ${vals.pop_address}, ${vals.pop_city}, ${vals.pop_state}<br>`},
    convenienceS: function (vals) {return`<h5>${capitalizeFirstLetter(vals.pop_name)}</h5><hr><b>Address:</b> ${vals.pop_address}<br><b>Phone:</b> ${vals.pop_phone}`},
    groceryS: function (vals) {return`<h5>${capitalizeFirstLetter(vals.pop_name)}</h5><hr><b>Address:</b> ${capitalizeFirstLetter(vals.pop_address)},${capitalizeFirstLetter(vals.pop_city)}, ${vals.pop_state}<br><b>Phone:</b> ${vals.pop_phone}`}
}

//Icons
var iconL = L.divIcon({
    className: "myDivIcon locate",
    html: locationString,
    popupAnchor: [10,0],
});
let markerL;
let icons = {};
for (const s in svgStrings){
    icons[s] = L.divIcon({
        className: `myDivIcon ${s}`,
        html: svgStrings[s],
        popupAnchor: [10,0]
    })
}
//end of icon sections



let map = L.map('map',
    {
        center: [41.825606, -71.407919],
        zoom: 13,
    });

let attribution = '&copy;' + mapLink + 'Developer '+ '| &copy;' + userLink + '';
L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png',{
    attribution:attribution,
}).addTo(map);

//map locate
map.locate({
    setView: false,
    maxZoom: 13,
    enableHighAccuracy: true,
});
map.addEventListener('locationfound', function (e) {
    map.panTo(e.latlng, {animate: false});
    markerL = new L.marker(e.latlng,
        {icon: iconL,
            bounceOnAdd: true,
            bounceOnAddOptions: {duration:1500}
        })
        .bindPopup("You are here!")
        .addTo(map)
        .openPopup();



});
map.addEventListener('locationerror', function (e) {
    //alert("Unable to locate; please enable your browser's location service!");
});
//end of map locating

//load all feature layers to map
Object.keys(layersIndex).forEach(item => {
    let _url = `${mapsURL}/${layersIndex[item]}`;
    layers[item] = L.esri.featureLayer({
        url: _url,
        pointToLayer: (geojson, latlng)=>{
            return L.marker(latlng, {icon: icons[item], pane: map.createPane(String(item))});},
        onEachFeature: (f, lyr)=>{
            let content = setPopup(f, item);
            lyr.bindPopup(content).addTo(map);
        }

    });
    layers[item].addTo(map);
});


//add eventlistener to layerWin item
let lyrLinks = document.querySelectorAll("#layerSel a");
lyrLinks.forEach(lyrLink=>{
    lyrLink.addEventListener('click',e =>{
        let lyrSlected = e.currentTarget.getAttribute("data-value");
        Object.keys(layers).forEach(lyr => {
            if (lyr != lyrSlected && map.hasLayer(layers[lyr])) {map.removeLayer(layers[lyr]);}
            else if (lyr == lyrSlected && ! map.hasLayer(layers[lyr])) {map.addLayer(layers[lyr]);}
            else{}
        });
        //update the text of the dropdown button
        dropdown_span.innerHTML = e.currentTarget.innerHTML.split("<small>")[0];


    })
})

function setPopup(feature, lyrName){

    let var_dict = vars_dict[lyrName];
    let attrs = feature.properties;
    let vals = {};
    Object.keys(var_dict).forEach(key => {
        vals[key] = attrs[var_dict[key]];
    })
    let content = popupHTMLs[lyrName](vals);

    return content;
}

//add geocoder control

let geocode_point;
const southWest = L.latLng(41.363407,-71.829872),
    northEast = L.latLng(42.006935,-71.250924),
    bounds = L.latLngBounds(southWest,northEast);
let geocoder = L.esri.Geocoding.geosearch({
    position: 'topleft',
    searchBounds: bounds,
    title: "Put in your address to find practices near you",
    placeholder: "RI Address search",
    zoomToResult: false
}).addTo(map);
let geocoder_result = L.layerGroup().addTo(map);
geocoder.addEventListener('results', results=>{
    geocoder_result.clearLayers();
    if (markerL != undefined) {
        map.removeLayer(markerL);
    };
    let result_1st = results.results[0].latlng;
    geocoder_result.addLayer(L.marker(result_1st, {riseOnHover:true, icon:iconL}));
    let nearest_points = get_nearest(result_1st,map, layers.groceryS ,8);
    //console.log(nearest_points);
    let nearest_bounds = L.latLngBounds(nearest_points);
    map.fitBounds(nearest_bounds);
    map.flyTo(result_1st);

});


function get_nearest(point,map,feature_layer,factor = 5){
    let arr_points = [];
    feature_layer.eachFeature(function(layer) {
        let feature = layer.feature;
        let fid_dis_point = {};
        //console.log(feature);
        let coor = {lat:feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0]};
        let point_current = L.latLng(coor);
        let id = feature.id;
        let dis = map.distance(point_current,point);
        fid_dis_point.fid = id;
        fid_dis_point.dis = dis;
        fid_dis_point.point = point_current;
        arr_points.push(fid_dis_point);
    });
    arr_points.sort((a,b)=> (a.dis > b.dis)? 1:-1);
    let top3 = arr_points.slice(0,factor);
    let bounds = [point];
    let fitbounds =[];
    top3.forEach(function (element) {
        bounds.push(element.point);
    });
    bounds.forEach(function (x) {
        fitbounds.push(Object.values(x));
    });
    return fitbounds;
};

